import ItodoImage from "../../../elements/itodo-img";
import { NavLink } from "react-router-dom";
import SectionTestimonials1 from "./section-testimonials1";

function SectionCaseStudy1() {
    return (
        <>
            <div className="section-full p-t110 p-b80 sx-bg-light sx-case-study-outer wow fadeInDown" data-wow-duration="1000ms" >
                <div className="container">
                    {/*Large Title*/}
                    <div className="large-title-block" style={{ direction: 'rtl' }}>
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                {/* TITLE START */}
                                <div className="section-head left" >
                                    <div className="sx-head-s-title">پروژه های ویراپ</div>
                                    <div className="sx-head-l-title">
                                        <h2 className="sx-title">نمونه‌کارهای اجراشده توسط ویراپ</h2>
                                    </div>
                                </div>
                                {/* TITLE END */}
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className=" large-title-info project-text">
                                    <p>ویراپ افتخار همکاری با سازمان تعزیرات حکومتی را در طراحی و پیاده‌سازی سامانه‌های مدیریتی و تحلیلی داشته است. در ادامه، خلاصه‌ای از پروژه‌های انجام‌شده توسط این تیم آورده شده است.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="section-content">
                        <div className="owl-carousel sx-case-st-carousel">
                            {/*One block*/}
                            <div className="item">
                                <div className="sx-case-study-bx sx-overlay-effect">
                                    <div className="sx-case-media sx-img-overlay">
                                        <NavLink to="/"><ItodoImage src="images/case-study/1.png" alt="" /></NavLink>
                                        <NavLink to="/" className="sx-case-link"><i className="flaticon-up-right-arrow" /></NavLink>
                                    </div>
                                    <div className="sx-case-info">
                                        <div className="sx-s-title">توسعه و نگهداری </div>
                                        <NavLink className="sx-l-title" to="/">
                                            <h2 className="sx-title">سامانه مدیریت پرونده‌ها</h2>
                                        </NavLink>
                                        <div className="sx-case-readmore">
                                            <NavLink to="/" title="READ MORE" rel="bookmark" className="site-button icon"><i className="fa  fa-long-arrow-left" />اطلاعات بیشتر</NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*One two*/}
                            <div className="item">
                                <div className="sx-case-study-bx sx-overlay-effect">
                                    <div className="sx-case-media sx-img-overlay">
                                        <NavLink to="/"><ItodoImage src="images/case-study/135.png" alt="" /></NavLink>
                                        <NavLink to="/" className="sx-case-link"><i className="flaticon-up-right-arrow" /></NavLink>
                                    </div>
                                    <div className="sx-case-info">
                                        <div className="sx-s-title">توسعه و نگهداری</div>
                                        <NavLink className="sx-l-title" to="/">
                                            <h2 className="sx-title">میز خدمت سازمان تعزیرات</h2>
                                        </NavLink>
                                        <div className="sx-case-readmore">
                                            <NavLink to="/" title="READ MORE" rel="bookmark" className="site-button icon"><i className="fa  fa-long-arrow-left" />اطلاعات بیشتر</NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*One three*/}
                            <div className="item">
                                <div className="sx-case-study-bx sx-overlay-effect">
                                    <div className="sx-case-media sx-img-overlay">
                                        <NavLink to="/"><ItodoImage src="images/case-study/pic-1.jpg" alt="" /></NavLink>
                                        <NavLink to="/" className="sx-case-link"><i className="flaticon-up-right-arrow" /></NavLink>
                                    </div>
                                    <div className="sx-case-info">
                                        <div className="sx-s-title">توسعه و نگهداری</div>
                                        <NavLink className="sx-l-title" to="/">
                                            <h2 className="sx-title">سامانه هوش تجاری سازمان تعزیرات</h2>
                                        </NavLink>
                                        <div className="sx-case-readmore">
                                            <NavLink to="/" title="READ MORE" rel="bookmark" className="site-button icon"><i className="fa  fa-long-arrow-left" />اطلاعات بیشتر</NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*One four*/}
                            <div className="item">
                                <div className="sx-case-study-bx sx-overlay-effect">
                                    <div className="sx-case-media sx-img-overlay">
                                        <NavLink to="/"><ItodoImage src="images/case-study/3.png" alt="" /></NavLink>
                                        <NavLink to="/" className="sx-case-link"><i className="flaticon-up-right-arrow" /></NavLink>
                                    </div>
                                    <div className="sx-case-info">
                                        <div className="sx-s-title">Devops</div>
                                        <NavLink className="sx-l-title" to="/">
                                            <h2 className="sx-title" dir="rtl">مشاوره نرم افزاری و Devops</h2>
                                        </NavLink>
                                        <div className="sx-case-readmore">
                                            <NavLink to="/" title="READ MORE" rel="bookmark" className="site-button icon"><i className="fa  fa-long-arrow-left" />اطلاعات بیشتر</NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*One five*/}
                            <div className="item">
                                <div className="sx-case-study-bx sx-overlay-effect">
                                    <div className="sx-case-media sx-img-overlay">
                                        <NavLink to="/"><ItodoImage src="images/case-study/2.png" alt="" /></NavLink>
                                        <NavLink to="/" className="sx-case-link"><i className="flaticon-up-right-arrow" /></NavLink>
                                    </div>
                                    <div className="sx-case-info">
                                        <div className="sx-s-title">توسعه و نگهداری</div>
                                        <NavLink className="sx-l-title" to="/">
                                            <h2 className="sx-title">سامانه امحاء</h2>
                                        </NavLink>
                                        <div className="sx-case-readmore">
                                            <NavLink to="/" title="READ MORE" rel="bookmark" className="site-button icon"><i className="fa  fa-long-arrow-left" />اطلاعات بیشتر</NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*One six*/}
                            <div className="item">
                                <div className="sx-case-study-bx sx-overlay-effect">
                                    <div className="sx-case-media sx-img-overlay">
                                        <NavLink to="/"><ItodoImage src="images/case-study/Ticketing.png" alt="" /></NavLink>
                                        <NavLink to="/" className="sx-case-link"><i className="flaticon-up-right-arrow" /></NavLink>
                                    </div>
                                    <div className="sx-case-info">
                                        <div className="sx-s-title">توسعه و نگهداری</div>
                                        <NavLink className="sx-l-title" to="/">
                                            <h2 className="sx-title">سامانه مدیریت پروژه و مکاتبات</h2>
                                        </NavLink>
                                        <div className="sx-case-readmore">
                                            <NavLink to="/" title="READ MORE" rel="bookmark" className="site-button icon"><i className="fa  fa-long-arrow-left" />اطلاعات بیشتر</NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*testimonial section */}
                        {/* <SectionTestimonials1 /> */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionCaseStudy1;